import hateoas from 'viralstyle-ui/src/hateoas';

export const getFeaturedCampaigns = async ({ state, dispatch, commit }) => {
  if (!state.featuredCampaigns.length) {
    let response = await dispatch('backgroundGet', hateoas.url('get_featured_campaigns'));

    commit('updateState', { object: state, property: 'featuredCampaigns', value: response.data });

    return response;
  }
};

export const getHomepageCampaigns = async ({ state, dispatch, commit }, category) => {
  if(!state[`${category.category.toLowerCase()}Campaigns`].length) {
    let response = await dispatch('backgroundGet', `${hateoas.url('marketplace_search_campaigns')}?from=0&size=3&filters[]=category:${category.id}&sort=age:desc`);

    commit('updateState', { object: state, property: `${category.category.toLowerCase()}Campaigns`, value: response.data.hits });

    return response;
  }
};